import { DatePipe } from '@angular/common';
import { NgxPermissionsService, NgxPermissionsModule } from 'ngx-permissions';
import { provideNgxMask } from 'ngx-mask';
import { provideAppInitializer, inject, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { AuthService } from './app/services/auth/auth.service';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { authInterceptor$ } from './app/common/interceptors/auth.interceptor';
import { provideApollo } from 'apollo-angular';
import { createApollo } from './app/apollo/apollo.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './app/shared/material/material.module';
import { App } from './app/app';

bootstrapApplication(App, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(
            ReactiveFormsModule,
            MaterialModule,
            NgxPermissionsModule.forRoot()
        ),
        provideRouter(routes),
        provideAnimations(),
        DatePipe,
        NgxPermissionsService,
        provideNgxMask(),
        provideAppInitializer(() => {
            const initializerFn = ((authService: AuthService) => {
                return async () => {
                    // Only load user info if there's an access token
                    if (authService.isLoggedIn()) {
                        try {
                            await authService.authRole();
                        } catch (error) {
                            console.warn('Failed to load user info on app init:', error);
                        }
                    }
                };
            })(inject(AuthService));
            return initializerFn();
        }),
        provideHttpClient(withXhr(), withInterceptors([
            // pendingRequestsInterceptor$,
            authInterceptor$
        ])),
        provideApollo(() => createApollo()),
    ]
})
  .catch(err => console.error(err));
